import { instance } from 'api/api';

export interface TestRunOffer {
    description: string;
    suggested_prompt: string;
}

export interface TestRunSuccess {
    status: 'success';
    narrative: string;
    significant: boolean;
    fallback_message: string;
}

export interface TestRunFailure {
    status: 'failure';
    failure_message: string;
    // The dataset path always emits the key (null when no offer); the external path omits it.
    offer?: TestRunOffer | null;
}

export type TestRunResult = TestRunSuccess | TestRunFailure;

export const aiInsightAPI = {
    async testRun(
        elementId: number,
        prompt: string,
        isConditional: string,
        fallbackMessage: string,
        urlPrefix: string = '/data/editor/element/extreport',
        reportAiInsightId: number = 0,
        primaryResource: string = '',
    ): Promise<TestRunResult> {
        const response = await instance.post<{ status: string; data: TestRunResult }>(
            `${urlPrefix}/${elementId}/ai-insight-test-run`,
            {
                prompt,
                isConditional,
                fallbackMessage,
                report_ai_insight_id: reportAiInsightId,
                primary_resource: primaryResource,
            },
        );

        return response.data.data;
    },
};
